import {gql} from '@apollo/client'

export const GET_CREDIT = gql`
  query GetCredit($creditId: ID!) {
    credit(id: $creditId) {
      id
      description
      amount
      date
      state
      xeroLink
      invoice {
        id
        invoiceNumber
      }
      isWriteoff
    }
  }
`

export const CREATE_CREDIT = gql`
  mutation CreateOrUpdateCredit(
    $description: String
    $amount: Float
    $date: String
    $accountId: ID
    $state: String
    $isWriteoff: Boolean
  ) {
    credit(
      description: $description
      amount: $amount
      date: $date
      accountId: $accountId
      state: $state
      isWriteoff: $isWriteoff
    ) {
      id
      description
      amount
      date
      state
      isWriteoff
    }
  }
`

export const UPDATE_CREDIT = gql`
  mutation CreateOrUpdateCredit(
    $creditId: ID!
    $description: String
    $amount: Float
    $date: String
    $accountId: ID
    $state: String
    $isWriteoff: Boolean
  ) {
    credit(
      id: $creditId
      description: $description
      amount: $amount
      date: $date
      accountId: $accountId
      state: $state
      isWriteoff: $isWriteoff
    ) {
      id
      description
      amount
      date
      state
      isWriteoff
    }
  }
`
